import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal, MaskedLines } from "@/components/Reveal";
import { FAQS } from "@/data/site";
import Seo from "@/components/Seo";

export default function FAQ() {
  return (
    <div className="bg-ink pt-[70px] md:pt-[84px]">
      <Seo title="Häufige Fragen (FAQ)" description="Alle Antworten zu STARSOX Grip-Socken: Grip, Material, Pflege, Versand, Rückgabe und Bestellung." path="/faq" />
      <section className="container-x pt-16 md:pt-24 pb-4">
        <p className="overline mb-4">Support</p>
        <MaskedLines start className="font-heading uppercase leading-[0.9]" lineClassName="text-6xl md:text-8xl" lines={["Häufige Fragen"]} />
        <p className="mt-6 text-white/50 max-w-xl">Alles, was du über STARSOX, Grip, Pflege, Versand und Bestellung wissen musst.</p>
      </section>

      <section className="container-x py-12 md:py-16 max-w-3xl">
        <Accordion type="single" collapsible defaultValue="f0">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`f${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-heading text-lg md:text-2xl uppercase tracking-wide text-left py-6 hover:no-underline hover:text-gold">{f.q}</AccordionTrigger>
              <AccordionContent className="text-white/60 leading-relaxed text-base pb-6">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>

      <section className="container-x pb-24">
        <Reveal>
          <div className="rounded-3xl border border-white/10 bg-carbon p-10 md:p-14 text-center">
            <h2 className="font-heading text-3xl md:text-5xl uppercase">Noch Fragen?</h2>
            <p className="text-white/50 mt-4">Wir helfen dir gerne persönlich weiter.</p>
            <Link to="/contact" data-testid="faq-contact" className="btn-primary mt-8">Kontakt aufnehmen <ArrowRight className="w-4 h-4" /></Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
